import type { RouteLocationNormalized, RouteLocationRaw, RouteParams } from "vue-router";

import { Schulform } from "@core/asd/types/schule/Schulform";
import { BenutzerKompetenz } from "@core/core/types/benutzer/BenutzerKompetenz";
import { ServerMode } from "@core/core/types/ServerMode";

import type { BenutzergruppeProps } from "~/components/einstellungen/benutzergruppen/daten/SBenutzergruppeProps";
import { type RouteEinstellungenBenutzergruppe, routeEinstellungenBenutzergruppe } from "~/router/apps/einstellungen/benutzergruppen/RouteEinstellungenBenutzergruppe";
import { routeEinstellungen } from "~/router/apps/einstellungen/RouteEinstellungen";
import { RouteNode } from "~/router/RouteNode";

const SBenutzergruppe = () => import("~/components/einstellungen/benutzergruppen/daten/SBenutzergruppe.vue");

export class RouteEinstellungenBenutzergruppeDaten extends RouteNode<any, RouteEinstellungenBenutzergruppe> {

	public constructor() {
		super(Schulform.values(), [BenutzerKompetenz.ADMIN], "einstellungen.benutzergruppe.daten", "daten", SBenutzergruppe);
		super.mode = ServerMode.STABLE;
		super.propHandler = (route) => this.getProps(route);
		super.text = "Benutzergruppe";
	}

	public async update(to: RouteNode<any, any>, to_params: RouteParams): Promise<void | Error | RouteLocationRaw> {
		if (routeEinstellungenBenutzergruppe.data.auswahl === undefined) {
			return routeEinstellungenBenutzergruppe.getRoute();
		}
	}

	public getProps(to: RouteLocationNormalized): BenutzergruppeProps {
		return {
			auswahl: () => routeEinstellungenBenutzergruppe.data.auswahl,
			alleBenutzer: () => routeEinstellungenBenutzergruppe.data.alleBenutzer,
			benutzerInBenutzergruppe: () => routeEinstellungenBenutzergruppe.data.benutzerInBenutzergruppe,
			manager: () => routeEinstellungenBenutzergruppe.data.manager,
			setBezeichnung: routeEinstellungenBenutzergruppe.data.setBezeichnung,
			setIstAdmin: routeEinstellungenBenutzergruppe.data.setIstAdmin,
			addKompetenz: routeEinstellungenBenutzergruppe.data.addKompetenz,
			removeKompetenz: routeEinstellungenBenutzergruppe.data.removeKompetenz,
			addBenutzerKompetenzGruppe: routeEinstellungenBenutzergruppe.data.addBenutzerKompetenzGruppe,
			removeBenutzerKompetenzGruppe: routeEinstellungenBenutzergruppe.data.removeBenutzerKompetenzGruppe,
			create: routeEinstellungenBenutzergruppe.data.create,
			addBenutzerToBenutzergruppe: routeEinstellungenBenutzergruppe.data.addBenutzerToBenutzergruppe,
			removeBenutzerFromBenutzergruppe: routeEinstellungenBenutzergruppe.data.removeBenutzerFromBenutzergruppe,
			gotoBenutzer: routeEinstellungenBenutzergruppe.data.gotoBenutzer,
			benutzerKompetenzen: routeEinstellungen.benutzerKompetenzen,
			mapBenutzergruppen: routeEinstellungenBenutzergruppe.data.mapBenutzergruppe,
		};
	}

}

export const routeEinstellungenBenutzergruppeDaten = new RouteEinstellungenBenutzergruppeDaten();

